var c = (t, o, r) => new Promise((s, i) => {
  var p = (e) => {
    try {
      a(r.next(e));
    } catch (n) {
      i(n);
    }
  }, d = (e) => {
    try {
      a(r.throw(e));
    } catch (n) {
      i(n);
    }
  }, a = (e) => e.done ? s(e.value) : Promise.resolve(e.value).then(p, d);
  a((r = r.apply(t, o)).next());
});
import { selfAxios as f } from "@oppein/op-utils";
function A(t) {
  return c(this, null, function* () {
    const {
      data: o
    } = yield f.post(
      "/designordercenter/productionOrder/aiOperation/createAiCancel",
      t
    );
    return o;
  });
}
export {
  A as postCreateAiCancel
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/aiOperation/createAiCancel/post.js
// module id = 1810
// module chunks = 67